import { getInfo } from '@/api/index.js'
import { loginMsg, logout } from '@/api/h5'
import { getToken, setToken, removeToken } from '@/common/auth'

const computeUserLevel = (userInfo) => {
  const { vipDate, auditSwitch, corporationStatus, licenseStatus, goodStatus } = userInfo
  const currentTime = new Date().getTime() / 1000 // 获取当前时间戳（秒）
  if (vipDate < currentTime && auditSwitch === 0) {
    return 1 // 普通用户
  } else if (vipDate > currentTime && auditSwitch === 0) {
    return 2 // 普通会员
  } else if (vipDate < currentTime && auditSwitch === 1 && ((corporationStatus === 1 && licenseStatus === 1) || (corporationStatus === 1 && goodStatus === 1))) {
    return 5 // 认证商家
  } else if (vipDate > currentTime && auditSwitch === 1 && ((corporationStatus === 1 && licenseStatus === 1) || (corporationStatus === 1 && goodStatus === 1))) {
    return 6 // 认证会员商家
  } else if (vipDate < currentTime && auditSwitch === 1 && !((corporationStatus === 1 && licenseStatus === 1) || (corporationStatus === 1 && goodStatus === 1))) {
    return 3 // 认证用户
  } else if (vipDate > currentTime && auditSwitch === 1 && !((corporationStatus === 1 && licenseStatus === 1) || (corporationStatus === 1 && goodStatus === 1))) {
    return 4 // 认证会员
  }
  return 0 // 未知状态
}

const store = {
  namespaced: true,
  state: {
    userInfo: '',
    token: '',
    userLevel: 0
  },

  mutations: {
    SET_USER_INFO: (state, data) => {
      state.userInfo = data
    },
    SET_TOKEN: (state, data) => {
      state.token = data
    },
    SET_USER_LEVEL: (state, data) => {
      state.userLevel = data
    }
  },
  actions: {
    // 用户登录
    login ({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        loginMsg(userInfo).then(result => {
          const { data } = result
          setToken(data.token)
          commit('SET_USER_INFO', data.userInfo)
          commit('SET_TOKEN', data.token)
          commit('SET_USER_LEVEL', computeUserLevel(data.userInfo))
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取用户信息
    getInfo ({ commit, state }) {
      return new Promise((resolve, reject) => {
        getInfo().then(result => {
          const { data } = result
          commit('SET_USER_INFO', data)
          commit('SET_TOKEN', getToken())
          commit('SET_USER_LEVEL', computeUserLevel(data))
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 退出登录
    logout ({ commit, state, dispatch }) {
      return new Promise((resolve, reject) => {
        logout().then(res => {
          commit('SET_TOKEN', '')
          removeToken()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 清除token
    resetToken ({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
      })
    }
  }
}

export default store
